export default "__VITE_ASSET__BZKN8GpU__"